import {
  GAME_ID,
  REDUX_ACTIONS,
  DROPZONE_KEYS,
  QUESTION_TYPES,
} from '../../data/planTorresConstants';

const initialState = {
  // word user should construct, correct word
  questionId: null,
  // word displayed initially, incorrect word
  referenceWord: null,
  // syllable user should choose in order to receive target word (empty for REMOVER interaction)
  targetSyllable: null,
  // syllable user should get rid of in order to receive target word (empty for ADDER interaction)
  referenceSyllable: null,
  // syllable user ACTUALLY chose during interaction
  selectedSyllable: null,
  // array of syllables from reference word
  referenceSyllables: [],
  // array of syllables from target word
  targetSyllables: [],
  // array of syllables user should choose from
  syllablesBank: [],
  // drag&drop interaction:
  // ADDER (user should add new syllable to reference word)
  // CHANGER (user should replace syllable in reference word)
  // REMOVER (user should remove syllable from reference word)
  interactionType: null,
  // amount of moves user performed, gets increased every time user dropped syllable inside of dropzone
  movesAmount: 0,
  // null initially, false/true if user's answer is incorrect/correct
  isAnswerCorrect: null,
  // relevant user's answer, gets changed every time user dropped syllable inside of dropzone
  userAnswer: null,
  // true, if step completed
  isStepCompleted: false,
  // hint 1
  hint1: null,
  // hint 2
  hint2: null,
  // list of phonemes for hint 1
  phonemes1: [],
  // list of phonemes for hint 2
  phonemes2: [],
  // question type
  questionType: null,
};

const getAdderInteractionAnswer = (state, payload) => {
  const selectedSyllable = payload.selectedSyllable || '';

  switch (payload.dropZoneKey) {
    // 2 cases for ADDER interaction
    case DROPZONE_KEYS.DROPZONE_RIGHT: {
      // add user's selected syllable at the end of reference word
      return state.referenceWord + selectedSyllable;
    }
    case DROPZONE_KEYS.DROPZONE_LEFT:
    default: {
      // add user's selected syllable in the beginning of reference word
      return selectedSyllable + state.referenceWord;
    }
  }
};

const getChangerInteractionAnswer = (state, payload) => state.referenceSyllables.map((syllable, index) =>
  // replace syllable (by selected index) in reference word with user's selected syllable
  (index === payload.referenceSyllableIndex ? payload.selectedSyllable : syllable),
).join('');

export const getRemoverInteractionAnswer = (referenceSyllables, referenceSyllableIndex) =>
  referenceSyllables.map((syllable, index) =>
    // replace syllable (by selected index) in reference word with emptiness
    (index === referenceSyllableIndex ? '' : syllable),
  ).join('');

const getServeAnswerNewState = (state, payload, userAnswer) => {
  const isAnswerCorrect = userAnswer === state.questionId;

  return {
    ...state,
    referenceSyllables: isAnswerCorrect ? state.targetSyllables : state.referenceSyllables,
    selectedSyllable: isAnswerCorrect ? payload.selectedSyllable : state.selectedSyllable,
    movesAmount: state.movesAmount + 1,
    isAnswerCorrect,
    userAnswer,
  };
};

const planTorresStandardStepReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_STANDARD_STEP: {
      return {
        ...initialState,
        ...action.payload,
        referenceWord: action.payload.referenceSyllables.join(''),
        questionId: action.payload.targetSyllables.join(''),
        questionType: action.payload.questionType || QUESTION_TYPES.STANDARD,
      };
    }
    case REDUX_ACTIONS.SERVE_ADDER_ANSWER: {
      return getServeAnswerNewState(
        state,
        action.payload,
        getAdderInteractionAnswer(state, action.payload),
      );
    }
    case REDUX_ACTIONS.SERVE_CHANGER_ANSWER: {
      return getServeAnswerNewState(
        state,
        action.payload,
        getChangerInteractionAnswer(state, action.payload),
      );
    }
    case REDUX_ACTIONS.SERVE_REMOVER_ANSWER: {
      return getServeAnswerNewState(
        state,
        action.payload,
        // if user selected some syllable during REMOVER interaction, this is ALREADY wrong
        // but we need to know user's relevant answer, so calculate it using CHANGER interaction method
        action.payload.selectedSyllable ?
          getChangerInteractionAnswer(state, action.payload) :
          getRemoverInteractionAnswer(state.referenceSyllables, action.payload.referenceSyllableIndex),
      );
    }
    case REDUX_ACTIONS.AUTO_COMPLETE_CORRECTLY: {
      return {
        ...state,
        referenceSyllables: state.targetSyllables,
        selectedSyllable: state.selectedSyllable,
        movesAmount: state.movesAmount + 1,
        isAnswerCorrect: true,
        userAnswer: `correct auto-complete: ${state.questionId}`,
      };
    }
    case REDUX_ACTIONS.AUTO_COMPLETE_INCORRECTLY: {
      return {
        ...state,
        movesAmount: state.movesAmount + 1,
        isAnswerCorrect: false,
        userAnswer: 'incorrect auto-complete',
      };
    }

    case REDUX_ACTIONS.COMPLETE_STEP: {
      return {
        ...state,
        referenceWord: state.questionId,
        isStepCompleted: true,
      };
    }
    default:
      return state;
  }
};

export default planTorresStandardStepReducer;
